import {
    Button, Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { ReactElement, } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { ExportMessstellenToExcel } from "../../../features/excelExport/ExportToExcel";
import { messstelle, schaltfeld } from "../../../utils/apiTypes";
import { isAuthorized, rollen } from "../../../utils/auth/authConfig";
import { addToObject } from "../../../utils/utils";
import {
    selectEditEntry, selectListLoading, selectMessstellen, selectSchaltfelder, startNewEntry
} from "./messstellenSlice";
import { useStyles } from "./messstellenStyles";



export default function MessstellenActionheader(): ReactElement {

    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };
    const rows: messstelle[] = useAppSelector(selectMessstellen),

        schaltfeldSelectList: schaltfeld[] = useAppSelector(selectSchaltfelder),
        editEntry: boolean = useAppSelector(selectEditEntry),
        listLoading: boolean = useAppSelector(selectListLoading);

    return (
        <React.Fragment>
            <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "16px" }}>
                <Grid item md={3} >
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                        Messstellen Übersicht
                    </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={3} />
                <Grid item md={3}>
                    {isAuthorized([rollen.admin, rollen.betrieb]) ?
                        <Button
                            variant="contained"
                            onClick={() => dispatch(startNewEntry())}
                            color="secondary"
                            className={classes.showDuoButton}
                            disabled={editEntry}
                        >
                            Neue Messstelle
                        </Button>
                        : ""}
                    <Button
                        variant="contained"
                        onClick={() => {
                            ExportMessstellenToExcel(rows.map(x => addToObject(x, "schaltfeldnummer", schaltfeldSelectList.find(y => y.umspannwerk == x.umspannwerk && y.name == x.schaltfeld)?.nummer, 4)), "messstellen");
                        }}
                        color="default"
                        className={classes.showDuoButton}
                        disabled={editEntry || listLoading}
                    >
                        Export
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
